module.exports = __webpack_public_path__ + "img/read.44d6670a.svg";